import FlightSearchApi from "@/services/FlightSearchApi";
import store from "../store";

export default {
  data() {
    return {
      loading: true
    };
  },
  getDepartingFlights(params) {
    store.commit("setLoading", true);
    return FlightSearchApi()
      .get("", {
        params
      })
      .then(function(response) {
        if (typeof response.data === "object") {
          store.commit("saveDepartingFlights", response.data);
        } else {
          console.log("INVALID RESULT for getDepartingFlights");
        }
      })
      .catch(function(error) {
        console.log("ERROR: ", error);
        store.commit("setErrorState", [
          "Departing",
          "Network Error. Please reload the page and try again."
        ]);
        store.commit("saveDepartingFlights", []);
      })
      .finally(function() {
        setTimeout(function(){
          store.commit("setLoading", false);
        }, 600);
      });
  },
  getReturningFlights(params) {
    store.commit("setLoading", true);
    return FlightSearchApi()
      .get("", {
        params
      })
      .then(function(response) {
        if (typeof response.data === "object") {
          store.commit("saveReturningFlights", response.data);
        } else {
          console.log("INVALID RESULT for getReturningFlights");
        }
      })
      .catch(function(error) {
        console.log(error);
      })
      .finally(function() {
        setTimeout(function(){
          store.commit("setLoading", false);
        }, 600);
      });
  },
  getNextLowestFare(params) {
    if (store.state.loadingLowest !== true) {
      // store.commit("loadingLowestFares", true);
      FlightSearchApi()
        .get("", {
          params
        })
        .then(function(response) {
          if (response.data.error !== undefined) {
            store.commit("clearLowestFares");
          } else if (typeof response.data === "object") {
            for (var day in response.data) {
              const lowestFare = {
                date: params.date,
                price: response.data[day],
                dir: params.dir
              };
              store.commit("addNextLowestFare", [lowestFare, params]);
            }
          } else {
            console.log("INVALID RESULT for getNextLowestFare");
          }
        })
        .catch(function(error) {
          console.log("ERROR:", error);
          setTimeout(function(){
            store.commit("loadingLowestFares", false);
          }, 100);
        });
    }
  },
  getLowestFare(params) {
    if (
      store.state.loadingLowest !== true &&
      params.end_loc > 0
    ) {
      // store.commit("loadingLowestFares", true);
      FlightSearchApi()
        .get("", {
          params
        })
        .then(function(response) {
          if (typeof response.data === "object") {
            store.commit("clearLowestFares");
            if (response.data.error !== undefined) {
              return 0;
            }
            for (var day in response.data) {
              const lowestFare = {
                date: day,
                price: response.data[day],
                dir: params.dir
              };
              store.commit("addLowestFare", lowestFare);
            }
          } else {
            console.log("INVALID RESULT for getLowestFare");
          }
        })
        .catch(function(error) {
          console.log("ERROR:", error);
          setTimeout(function(){
            store.commit("loadingLowestFares", false);
          }, 100);
        });
    }
  },
  getBookingSummary(params) {
    // const qs = require('qs');
    const paramData = Object.entries(params)
      .map(([key, val]) => `${key}=${encodeURIComponent(val)}`)
      .join('&');
    store.commit("setLoading", true);
    FlightSearchApi()
    .post("", params)
    .then(function(response) {
      if (typeof response.data === "object") {
        store.commit("addBookingLineItems", response.data);
      } else {
        console.log("INVALID RESULT for getBookingSummary");
      }
      store.commit("setLoading", false);
    })
    .catch(function(error) {
      console.log("ERROR:", error);
      store.commit("setLoading", false);
    });
  },
  printBookingReceipt(params) {
    console.log("TCL: printBookingReceipt -> params", params);
    FlightSearchApi()
      .get("", {
        params
      })
      .then(function(response) {
        if (response.data.error !== undefined) {
          console.log("PRINT ERROR: ", response.data.error);
        } else {
          console.log("PRINT COMPLETE: ", response);
        }
      })
      .catch(function(error) {
        console.log("PRINT ERROR:", error);
      });
  }
};
